// @flow strict
import { graphql } from 'gatsby';
import React from 'react';
import Layout from '../components/Layout';
import Post from '../components/Post';
import { useSiteMetadata } from '../hooks';
import type { MarkdownRemark } from '../types';

type Props = {
  data: {
    markdownRemark: MarkdownRemark,
  },
};

const PostTemplate = ({ data }: Props) => {
  const { title: siteTitle, subtitle: siteSubtitle } = useSiteMetadata();
  const { frontmatter } = data.markdownRemark;
  const {
    title: postTitle,
    description: postDescription,
    socialImage: customSocialImage,
  } = frontmatter;
  const metaDescription = postDescription !== null ? postDescription : siteSubtitle;

  const { slug } = data.markdownRemark.fields;
  const generatedSocialImage = `${slug}/thumbnail.png`;
  const socialImage = customSocialImage != null ? customSocialImage : generatedSocialImage;

  return (
    <Layout
      title={`${postTitle} - ${siteTitle}`}
      description={metaDescription}
      socialImage={socialImage}
      largeTwitterCard={true}
    >
      <Post post={data.markdownRemark} />
    </Layout>
  );
};

export const query = graphql`
  query PostBySlug($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      fields {
        slug
        tagSlugs
        autoRecommendPosts
      }
      frontmatter {
        date
        description
        tags
        title
        socialImage
        recommendPosts
      }
    }
  }
`;

export default PostTemplate;
